import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line consistent-return
export var handleKeyboardClick = function handleKeyboardClick(fn) {
  return function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      return fn(e);
    }
  };
};
export var getPopoverDirection = function getPopoverDirection(targetRect, popoverRect) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$offsetLeft = options.offsetLeft,
      offsetLeft = _options$offsetLeft === void 0 ? 0 : _options$offsetLeft,
      _options$offsetBottom = options.offsetBottom,
      offsetBottom = _options$offsetBottom === void 0 ? 0 : _options$offsetBottom;
  var hasRects = !!targetRect && !!popoverRect;
  var collisions = {
    top: hasRects && targetRect.top - popoverRect.height < 0,
    right: hasRects && window.innerWidth < targetRect.left + popoverRect.width - offsetLeft,
    bottom: hasRects && window.innerHeight < targetRect.bottom + popoverRect.height - offsetBottom,
    left: hasRects && targetRect.left - popoverRect.width < 0
  };
  return {
    right: collisions.right && !collisions.left,
    up: collisions.bottom && !collisions.top
  };
};
export var getRelativePopoverStyles = function getRelativePopoverStyles(targetRect, popoverRect) {
  var _ref;

  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _getPopoverDirection = getPopoverDirection(targetRect, popoverRect, options),
      up = _getPopoverDirection.up,
      right = _getPopoverDirection.right;

  return _ref = {}, _defineProperty(_ref, options.positionTop || up ? 'bottom' : 'top', '100%'), _defineProperty(_ref, options.positionRight || right ? 'right' : 'left', '0'), _ref;
};
export var getTabbableDescendants = function getTabbableDescendants(node) {
  var inputOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var options = _objectSpread({
    a: true,
    '[tabindex]': true,
    input: true,
    button: true,
    textarea: true,
    select: true
  }, inputOptions);

  var selector = Object.keys(options).reduce(function (acc, key) {
    var value = options[key];

    if (value) {
      acc.push(key);
    }

    return acc;
  }, []).join(', ');
  return [].slice.call(node.querySelectorAll(selector)).filter(function (element) {
    var isEnabled = !element.disabled;
    var isInTabIndex = element.tabIndex !== -1;
    return isEnabled && isInTabIndex;
  });
};